












































import { Component, Mixins, Prop } from 'vue-property-decorator';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';

@Component({
    components: {
    },
})
export default class AuthWrapper extends Mixins(IsMobileMixin) {
    @Prop() public backgroundImage!: any;
    @Prop() public logoImage!: any;
    @Prop({ default: '#1b48a7' }) public backgroundColor!: any;

    public goToHome() {
        this.$router.push('/');
    }

    get logoStyle() {
        return {};
    }

    get authWrapperStyle() {
        return {
            'background-color': this.backgroundColor,
            'background-image': `url(${this.backgroundImage})`,
            'background-repeat': 'no-repeat',
            'background-attachment': 'fixed',
            'background-position': 'center',
        };
    }
}

